'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.rightHelp = exports.leftHelp = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _DefaultString = require('../../helpers/DefaultString');

var _Logs = require('../../helpers/Logs');

var _Router = require('../../helpers/Router');

var _HelpButton = require('./HelpButton.scss');

var _HelpButton2 = _interopRequireDefault(_HelpButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var leftHelp = exports.leftHelp = 'left';
var rightHelp = exports.rightHelp = 'right';

var HelpButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HelpButton, _Component);

  function HelpButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HelpButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HelpButton.__proto__ || (0, _getPrototypeOf2.default)(HelpButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showHelp: false
    }, _this.onHelp = function () {
      var source = void 0;
      var destination = void 0;
      if (_this.state.showHelp) {
        source = _Logs.LogName.HelpInfo;
        destination = _this.props.log.src;
      } else {
        source = _this.props.log.src;
        destination = _Logs.LogName.HelpInfo;
      }
      (0, _Logs.logNavigationPopup)(source, destination, _this.props.log, _this.props.auth, _this.props.appInfo);
      _this.setState({ showHelp: !_this.state.showHelp });
    }, _this.onContactUs = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ContactUs));
      _this.onHelp();
    }, _this.getTransitionName = function () {
      return 'help-transition-' + _this.props.className;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HelpButton, [{
    key: 'render',
    value: function render() {
      var showHelp = this.state.showHelp;

      var transitionName = this.getTransitionName();
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: _HelpButton2.default.help, onClick: this.onHelp },
          '?'
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: transitionName,
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 300
          },
          showHelp ? _react2.default.createElement(
            'div',
            { key: 'openPopup', className: _HelpButton2.default.popupContent },
            _react2.default.createElement('div', { className: _HelpButton2.default.overlay, onClick: this.onHelp }),
            _react2.default.createElement(
              'div',
              { className: _HelpButton2.default.messageContent },
              _react2.default.createElement(
                'div',
                { className: _HelpButton2.default.messages },
                _react2.default.createElement(
                  'div',
                  { className: _HelpButton2.default.stingrayFamily },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.StingrayFamilyDescription)
                ),
                _react2.default.createElement(
                  'div',
                  { className: _HelpButton2.default.contactUs, onClick: this.onContactUs },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ContactUsTextOnly)
                )
              ),
              _react2.default.createElement('div', { className: _HelpButton2.default.arrow })
            )
          ) : _react2.default.createElement('div', { key: 'closePopup' })
        )
      );
    }
  }]);
  return HelpButton;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = HelpButton;


//////////////////
// WEBPACK FOOTER
// ./src/components/HelpButton/HelpButton.js
// module id = 409
// module chunks = 0